// extracted by mini-css-extract-plugin
export default {"saved":"Icons_saved__C3fBE"};